/* eslint-disable quotes */
/* eslint-disable max-len */
// Dependencies
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import ReactMarkdown from 'react-markdown'

// import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesStepContainer from '../styles/StepContainer.module.css'
import Helpers from '../Helpers'
import {Select} from '@lazarusai/forms-ui-components'
import FileRender from './FileRender'
import {JSONTree} from 'react-json-tree'

// Components

function StepContainer({
  step = {},
  isFinal = false,
  isSummary = false,
  title = 'TITLE',
  taskFiles = {},
  startTime,
  isStepError,
  logKey,
  ...props
}) {
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileDivHeight, setFileDivHeight] = useState('calc(100% - 100px)')
  const [localStep, setLocalStep] = useState({})

  useEffect(() => {
    if (step?.action?.time !== localStep?.action?.time) {
      setLocalStep(step)
      if ((step?.sources?.length || 0) > 0) {
        setSelectedFile(step?.sources?.[0])
      }
    }
    if ((step?.output_sources?.length || 0) > 0) {
      setSelectedFile(step?.output_sources?.[0])
    }
  }, [step])

  useEffect(() => {
    if (selectedFile) {
      const selectedType = Helpers.fileTypeFormatFromName(selectedFile)
      if (['Document', 'Image'].some((val) => val === selectedType)) {
        setFileDivHeight('calc(100% - 100px)')
      } else {
        setFileDivHeight('auto')
      }
    }
  }, [selectedFile])

  const finalStepRender = (
    <>
      <div
        className={stylesStepContainer['step-container-key']}
        style={{marginBottom: '24px'}}
      >
        Final Output
      </div>
      <div
        className={stylesStepContainer['step-container-kv']}
        style={{marginBottom: '24px', display: 'flex', gap: '36px'}}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
          Total Time
        </div>
        <div
          className={stylesStepContainer['step-container-value']}
        >
          {Helpers.formatTimeDelta(step?.time - startTime)}
        </div>
      </div>
      <div
        className={stylesStepContainer['step-container-section']}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
        Explanation
        </div>
        <div
          className={`${stylesStepContainer['step-container-value']}`}
        >
          {step?.explanation}
        </div>
      </div>
      <div
        className={stylesStepContainer['step-container-section']}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
        Response
        </div>
        <div
          className={`${stylesStepContainer['step-container-value']}`}
        >
          <ReactMarkdown>{step?.content}</ReactMarkdown>
        </div>
      </div>
      {(step?.['output_sources']?.length || 0) > 0 && <>
        <div
          className={stylesStepContainer['step-container-row']}
        >
          <div
            className={stylesStepContainer['step-container-section']}
            style={{margin: '0px'}}
          >
            <div
              className={stylesStepContainer['step-container-key']}
            >
            Files
            </div>
            <div
              className={`${stylesStepContainer['step-container-info']}`}
            >
            Preview files used in this log
            </div>
          </div>
          <Select
            onClickOption={(selectOption) => {
              setSelectedFile(selectOption)
            }}
            value={selectedFile}
            theme={props.theme}
            options={step?.output_sources}
          />
        </div>
        {selectedFile && <div
          style={{
            width: '100%',
            height: fileDivHeight,
            maxHeight: '45vw',
            marginBottom: '12px',
          }}
        >
          <FileRender
            file={taskFiles[selectedFile]?.file}
          />
        </div>}
      </>}
    </>
  )

  const summaryStepRender = (
    <>
      <div
        className={stylesStepContainer['step-container-key']}
        style={{marginBottom: '24px'}}
      >
        Conclusion
      </div>
      <div
        className={stylesStepContainer['step-container-kv']}
        style={{marginBottom: '24px', display: 'flex', gap: '36px'}}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
          Total Time
        </div>
        <div
          className={stylesStepContainer['step-container-value']}
        >
          {Helpers.formatTimeDelta(step?.time - startTime)}
        </div>
      </div>
      <div
        className={stylesStepContainer['step-container-section']}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
        Response
        </div>
        <div
          className={`${stylesStepContainer['step-container-value']}`}
        >
          <ReactMarkdown>{step?.content}</ReactMarkdown>
        </div>
      </div>
    </>
  )

  const stepRender = (
    <>
      <div
        className={stylesStepContainer['step-container-row']}
      >
        <div
          className={stylesStepContainer['step-container-kv']}
        >
          <div
            className={stylesStepContainer['step-container-key']}
          >
          time
          </div>
          <div
            className={stylesStepContainer['step-container-value']}
          >
            {Helpers.timeStampToDateAndTime(step?.action?.time)}
          </div>
        </div>
        <div
          className={stylesStepContainer['step-container-kv']}
        >
          <div
            className={stylesStepContainer['step-container-key']}
          >
          action
          </div>
          <div
            className={stylesStepContainer['step-container-value']}
          >
            {Helpers.snakeCaseToDisplay(step?.action?.tool_calls?.[0]?.function?.name || '')}
          </div>
        </div>
        <div
          className={stylesStepContainer['step-container-kv']}
        >
          <div
            className={stylesStepContainer['step-container-key']}
          >
          status
          </div>
          <div
            className={`${stylesStepContainer['step-container-value']} ${stylesStepContainer[step?.['action-output'] ? step?.['action-output']?.content ? 'step-container-value-success' : 'step-container-value-error' : '']}`}
          >
            {step?.['action-output'] ? step?.['action-output']?.content ? 'SUCCESS' : 'FAILURE' : isStepError ? 'ERROR': 'RUNNING'}
          </div>
        </div>
        <div
          className={stylesStepContainer['step-container-kv']}
        >
          <div
            className={stylesStepContainer['step-container-key']}
          >
          Call ID
          </div>
          <div
            className={`${stylesStepContainer['step-container-value']}`}
          >
            {logKey}
          </div>
        </div>
        {step?.['action-output']?.time > 0 && step?.action?.time > 0 && props.taskId !== 'car_demo_v2' && <div
          className={stylesStepContainer['step-container-kv']}
        >
          <div
            className={stylesStepContainer['step-container-key']}
          >
          Elapsed Time
          </div>
          <div
            className={stylesStepContainer['step-container-value']}
          >
            {Helpers.formatTimeDelta(step?.['action-output']?.time - step?.action?.time)}
          </div>
        </div>}
      </div>
      <div
        className={stylesStepContainer['step-container-section']}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
        Request
        </div>
        <div
          className={`${stylesStepContainer['step-container-value']}`}
        >
          {step?.['action']?.explanation ?
            step?.['action']?.explanation :
            Helpers.isStringJSON(step?.['action']?.['tool_calls']?.[0]?.['function']?.['arguments'] || '') ?
                <JSONTree
                  data={JSON.parse(step?.['action']?.['tool_calls']?.[0]?.['function']?.['arguments'])}
                  theme={{
                    oragng: '#FA0',
                    base00: '#272822',
                    base01: '#383830',
                    base02: '#49483e',
                    base03: '#75715e',
                    base04: '#a59f85',
                    base05: '#f8f8f2',
                    base06: '#f5f4f1',
                    base07: '#f9f8f5',
                    base08: '#f92672',
                    base09: '#FA0',
                    base0A: '#f4bf75',
                    base0B: '#ffffff',
                    base0C: '#a1efe4',
                    base0D: '#51FFC8',
                    base0E: '#ae81ff',
                    base0F: '#cc6633',
                    tree: () => ({className: stylesStepContainer['json-tree']}),
                  }}
                  hideRoot
                  shouldExpandNodeInitially={(keyPath, data, level) => {
                    return level < 4
                  }}
                /> :
                step?.['action']?.['tool_calls']?.[0]?.['function']?.['arguments'] ||
                step?.['action']?.['tool_calls']?.[0]?.['function']?.['name'] ||
                ''
          }
        </div>
      </div>
      {(step?.['sources']?.length || 0) > 0 && <>
        <div
          className={stylesStepContainer['step-container-row']}
        >
          <div
            className={stylesStepContainer['step-container-section']}
            style={{margin: '0px'}}
          >
            <div
              className={stylesStepContainer['step-container-key']}
            >
            Files
            </div>
            <div
              className={`${stylesStepContainer['step-container-info']}`}
            >
            Preview files used in this log
            </div>
          </div>
          <Select
            onClickOption={(selectOption) => {
              setSelectedFile(selectOption)
            }}
            value={selectedFile}
            theme={props.theme}
            options={step?.sources}
          />
        </div>
        {selectedFile && <div
          style={{
            width: '100%',
            height: fileDivHeight,
            maxHeight: '45vw',
            marginBottom: '12px',
          }}
        >
          <FileRender
            file={taskFiles[selectedFile]?.file}
          />
        </div>}
      </>}
      {step?.['action-output'] &&
      <div
        className={stylesStepContainer['step-container-section']}
        style={{
          paddingBottom: '24px',
        }}
      >
        <div
          className={stylesStepContainer['step-container-key']}
        >
          Response
        </div>
        <div
          className={`${stylesStepContainer['step-container-value']}`}
        >
          {Helpers.isStringJSON((step?.['action-output']?.content?.[0] === '[') ? step?.['action-output']?.content.replaceAll("'", '"') : step?.['action-output']?.content) ?
            <JSONTree
              data={JSON.parse((step?.['action-output']?.content?.[0] === '[') ? step?.['action-output']?.content.replaceAll("'", '"') : step?.['action-output']?.content)}
              theme={{
                oragng: '#FA0',
                base00: '#272822',
                base01: '#383830',
                base02: '#49483e',
                base03: '#75715e',
                base04: '#a59f85',
                base05: '#f8f8f2',
                base06: '#f5f4f1',
                base07: '#f9f8f5',
                base08: '#f92672',
                base09: '#FA0',
                base0A: '#f4bf75',
                base0B: '#ffffff',
                base0C: '#a1efe4',
                base0D: '#51FFC8',
                base0E: '#ae81ff',
                base0F: '#cc6633',
                tree: () => ({className: `${stylesStepContainer['json-tree']} ${(step?.['action-output']?.content?.[0] === '[') ?stylesStepContainer['json-tree-hide-long-links'] : ''}`}),
              }}
              hideRoot
              shouldExpandNodeInitially={(keyPath, data, level) => {
                return level < 4
              }}
            />:
            step?.['action-output']?.content
          }
        </div>
      </div>
      }
      {(step?.['output_sources']?.length || 0) > 0 && <>
        <div
          className={stylesStepContainer['step-container-row']}
        >
          <div
            className={stylesStepContainer['step-container-section']}
            style={{margin: '0px'}}
          >
            <div
              className={stylesStepContainer['step-container-key']}
            >
            Files
            </div>
            <div
              className={`${stylesStepContainer['step-container-info']}`}
            >
            Preview files used in this log
            </div>
          </div>
          <Select
            onClickOption={(selectOption) => {
              setSelectedFile(selectOption)
            }}
            value={selectedFile}
            theme={props.theme}
            options={step?.output_sources}
          />
        </div>
        {selectedFile && <div
          style={{
            width: '100%',
            height: fileDivHeight,
            maxHeight: '45vw',
            marginBottom: '12px',
          }}
        >
          <FileRender
            file={taskFiles[selectedFile]?.file}
          />
        </div>}
      </>}
    </>
  )

  return (
    <div
      className={stylesStepContainer['step-container-wrapper']}
    >
      {isFinal ?
        finalStepRender :
        isSummary ?
          summaryStepRender :
          stepRender
      }
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  taskId: state.userReducer.taskId,
})

export default connect(
    mapStateToProps,
    {},
)(StepContainer)
